import { ActionTree, GetterTree, MutationTree, Module } from "vuex";
import { action, createModule, mutation } from "vuex-class-component";
import { onMounted } from "vue";
import rest from "@/rest";
import _ from "lodash";
import GlobalHelper from '@/classes/common/globalHelper';
import { RootStore } from "../types";
import { OrganizationVm, PortalUserVM } from "@/interfaces/PortalUserVM";
import { ExBundleVM } from "@/interfaces/ExBundleVM";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
// import { ExSubject } from "@/interfaces/ExSubject";
import { ExBundleAssignmentVM } from "@/interfaces/ExBundleAssignmentVM";
import { GroupExtVm } from "@/interfaces/GroupExtVm";
import { ExCategory1 } from "@/interfaces/ExCategory1";
import { ExCategory2 } from "@/interfaces/ExCategory2";
import { ExCategory3 } from "@/interfaces/ExCategory3";
import { SubGroupVm } from "@/interfaces/SubGroupVm";
// import { SurveyDetailedVm } from "@/interfaces/SurveyDetailedVm";
import { ExSurveyVm } from "@/interfaces/ExSurveyVm";
import { VCardInfoVm } from "@/interfaces/VCardInfoVm";
import { CcPageVm, CourseElementVm } from "@/interfaces/CcPageVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { lang } from "moment";

const VuexModule = createModule({
  strict: false,
  namespaced: "globals",
});

export class Globals extends VuexModule {
  sSelectedOrg: OrganizationVm | null = null;
  sSelectedGroup: GroupExtVm | null = null;
  sSelectedSubGroup: SubGroupVm | null = null;
  sSelectedGroupMembers: any = null;
  sSelectedUser: any = null;
  sSelectedCategory1: ExCategory1 | null = null;
  sSelectedCategory2: ExCategory2 | null = null;
  sSelectedCategory3: ExCategory3 | null = null;
  sSelectedExBundleAssignment: any = null;
  sGroupAssignment: ExBundleAssignmentVM | null = null;
  _SelectedBundle: ExBundleVM | null = null;
  _SelectedLanguageCode: string | null = null;
  _SelectedExercise: ExerciseVM | null = null;
  _ModulePages: CcPageVm[] | null = null;
  _LastUpdatedModulePages: CcPageVm[] | null = null;
  _SelectedModulePage: CcPageVm | null = null;
  _SelectedCourseElement: CourseElementVm | null = null;
  _SelectedSurvey: ExSurveyVm | null = null;
  _vCard: VCardInfoVm | null = null;

  sIsInPrintMode = false;
  sShowPrintUsersQrCode = false;

  // groupExerciseOverview
  sGroupExerciseOverviewSortByAlphabet = true
  sGroupExerciseOverviewSortOrderAscending = true

  // Not working!
  // mounted() {
  //   this.LoadVCardFromLocal();
  // }

  // getters
  get selectedUser() {
    return this.sSelectedUser;
  }
  get selectedOrg() {
    return this.sSelectedOrg;
  }
  // get pupilsOfSelectedClass() {
  //   return this.sPupilsOfSelectedClass;
  // }
  get selectedGroup() {
    return this.sSelectedGroup;
  }
  get selectedSubGroup() {
    return this.sSelectedSubGroup;
  }
  get selectedCategory1() {
    return this.sSelectedCategory1;
  }
  get selectedCategory2() {
    return this.sSelectedCategory2;
  }
  get selectedCategory3() {
    return this.sSelectedCategory3;
  }
  get selectedExBundleAssignment() {
    return this.sSelectedExBundleAssignment;
  }
  get selectedGroupAssignment() {
    return this.sGroupAssignment;
  }
  get selectedBundle() {
    return this._SelectedBundle;
  }
  get selectedLanguageCode() {
    return this._SelectedLanguageCode;
  }
  get isMasterLanguageCode() {
    if (!this._SelectedBundle || !this._SelectedLanguageCode) return true;
    return this._SelectedBundle.masterLanguageCode == this._SelectedLanguageCode;
  }
  get selectedExercise() {
    return this._SelectedExercise;
  }
  get modulePages() {
    return this._ModulePages;
  }
  get selectedModulePage() {
    return this._SelectedModulePage;
  }
  get selectedModulePageIndex(): number {
    if (!this._ModulePages || this._ModulePages.length == 0 || !this._SelectedModulePage) {
      return 0;
    }

    const index = this._ModulePages.indexOf(this._SelectedModulePage) + 1;
    return index;
  }
  get selectedElement() {
    return this._SelectedCourseElement;
  }
  get selectedSurvey() {
    return this._SelectedSurvey;
  }
  get isInPrintMode() {
    return this.sIsInPrintMode;
  }
  get showPrintUsersQrCode() {
    return this.sShowPrintUsersQrCode;
  }
  get groupExerciseOverviewSortByAlphabet() {
    return this.sGroupExerciseOverviewSortByAlphabet;
  }
  get groupExerciseOverviewSortOrderAscending() {
    return this.sGroupExerciseOverviewSortOrderAscending;
  }
  // childQuestions(){
  //   return this.childQuestions;
  // }
  // selectedChildQuestionId(){
  //   return this.selectedChildQuestionId;
  // }
  // selectedChildQuestion(){
  //   if (!this.childQuestions)
  //     return null;

  //   return this.childQuestions[this.selectedChildQuestionId];
  // }

  @action async SelectGroup(group: GroupExtVm | null) {
    this.setGroup(group);
    // Get users
    // let users: PortalUserVM[] = [];
    // if (group)
    //   users = await rest.url("groupAdmin/getUsers").query({ groupId: group.id }).get();

    // this.setUsersOfGroup(users);
  }

  @action async LoadVCardFromLocal() {
    const vCardString = localStorage.getItem('vCard');
    if (vCardString) {
      this._vCard = JSON.parse(vCardString);
      return;
    }

    this._vCard =  null;
  }

  @action async LoadVCardFromDb() {
    // console.log("LoadVCardFromDb");

    const vCardInDb: VCardInfoVm | null = await rest.url("public/vCardInfo").get();

    // If there is no vCard in DB, clear local storage
    if (!vCardInDb) {
      console.log("Clear stored vCard");
      window.localStorage.removeItem("vCard");
      this.setVCard(null);
      return;
    }

    // Load local vCard
    const vCardString = localStorage.getItem('vCard');
    let vCardLocal: VCardInfoVm | null = null;
    if (vCardString) {
      vCardLocal = JSON.parse(vCardString);
    }

    // If local vCard is from different user, clear local storage
    if (vCardLocal && vCardLocal.portalUserId != vCardInDb.portalUserId) {
      console.log("Clear stored vCard");
      window.localStorage.removeItem("vCard");
    }

    // If there is a local vCard from the same user, update it
    if (vCardLocal && vCardLocal.portalUserId == vCardInDb.portalUserId) {
      // console.log("Update vCard");
      vCardInDb.saveOnDevice = true;
      const vCardString = JSON.stringify(vCardInDb);
      window.localStorage.setItem("vCard", vCardString);
    }

    this.setVCard(vCardInDb);
  }

  @action async UpdateVCard(vCard: VCardInfoVm | null) {
    if (!vCard) {
      console.log("clear stored vCard");
      window.localStorage.removeItem("vCard");
      this.setVCard(null);
      return;
    }

    this.setVCard(vCard);

    // Update in local storage
    if (vCard.saveOnDevice) {
      console.log("store vCard in local storage");
      const vCardString = JSON.stringify(vCard);
      window.localStorage.setItem("vCard", vCardString);
    } else {
      console.log("clear stored vCard");
      window.localStorage.removeItem("vCard");
    }
  }

  get vCard(): VCardInfoVm | null {
    return this._vCard;
  }

  @mutation setVCard(vCard: VCardInfoVm | null) {
    this._vCard = vCard;
  }

  // Module pages
  @action async selectExercise(exercise: ExerciseVM | null) {
    if (exercise == this._SelectedExercise) {
      console.log("globals > selectExercise: Exercise already selected, no need to reload module pages");
      return;
    }

    console.log("globals > selectExercise");
    await this.saveModulePages(false);
    await this.setExercise(exercise);
    await this.loadModulePages();
  }

  @action async loadModulePages() {
    if (!this.selectedExercise?.id) return;
    // this.setAndIndexModulePages(null);
    console.log("globals > loadModulePages");

    let modulePages: CcPageVm[] = await rest
      .url("contentManager/getCcModulePages")
      .query({ exerciseId: this.selectedExercise.id, languageCode: this.selectedLanguageCode ?? "de-DE" })
      .get();

    // If exercise has not changed, do not reset current selection of module page
    let newExerciseId = modulePages && modulePages.length > 0 ? modulePages[0].exerciseId : 0;
    console.log("globals > loadModulePages: loaded module pages for exercise id: ", newExerciseId);
    console.log("globals > loadModulePages: current selected exercise id: ", this._SelectedExercise?.id);
    let restoreSelectedPageIndex = false;
    let prevSelectedModulePageId = this._SelectedModulePage?.id;
    if (this._SelectedExercise && this._SelectedExercise.id == newExerciseId) {
      console.log("globals > loadModulePages: Exercise has not changed, keep current selection of module page");
      restoreSelectedPageIndex = true;
    }

    await this.setAndIndexModulePages({ modulePages: modulePages, resetCurrentSelection: !restoreSelectedPageIndex });

    // if restoreSelectedPageIndex is true, try to restore the previously selected module page by id, if it still exists in the new loaded module pages
    if (restoreSelectedPageIndex && prevSelectedModulePageId) {
      let index = this._ModulePages?.findIndex((p) => p.id == prevSelectedModulePageId) ?? -1;
      if (index != -1) {
        console.log("globals > loadModulePages: restore selected module page with id: ", prevSelectedModulePageId);
        await this.selectModulePage(index);
        await this.cloneModulePages();
        return;
      } else {
        console.log("globals > loadModulePages: previously selected module page with id ", prevSelectedModulePageId, " not found in loaded module pages");
      }
    }

    if (!this._SelectedModulePage && this._ModulePages && this._ModulePages.length > 0) {
      console.log("globals > loadModulePages: select first page");
      await this.selectModulePage(0);
    }

    if (!this._ModulePages || this._ModulePages.length == 0) {
      console.log("globals > loadModulePages: no module pages found, adding and selecting a new page");
      await this.addAndSelectModulePage();
    }

    await this.cloneModulePages();
  }

  @action async setModulePages(modulePages: CcPageVm[] | null) {
    // console.log("globals > setModulePages");
    this.setAndIndexModulePages({ modulePages: modulePages, resetCurrentSelection: false });
  }

  @mutation setAndIndexModulePages(data: { modulePages: CcPageVm[] | null, resetCurrentSelection: boolean }) {
    this._ModulePages = data.modulePages;
    if (data.resetCurrentSelection)
      this._SelectedModulePage = null;
    // update id of all module pages
    if (this._ModulePages) {
      for (let i = 0; i < this._ModulePages.length; i++) {
        this._ModulePages[i].id = i + 1;
      }
    }
  }

  @mutation cloneModulePages() {
    console.log("globals > cloneModulePages");
    this._LastUpdatedModulePages = _.cloneDeep(this._ModulePages);
  }

  @action async saveModulePages(force: boolean = false) {
    if (!this._ModulePages || this._ModulePages.length == 0)
      return;

    if (!force && _.isEqual(this._LastUpdatedModulePages, this._ModulePages)) {
        console.log("globals > saveModulePages: NO Changes for id: ", this._ModulePages[0].exerciseId);
        return;
    }

    console.log("globals > saveModulePages: saving changes for id: ", this._ModulePages[0].exerciseId);
    let translationRequired = await rest.url("contentManager/saveCcModulePages").post(this._ModulePages);
    if (translationRequired && this._SelectedBundle) {
      this._SelectedBundle.translationRequired = true;
    }

    if (this._SelectedLanguageCode != this._SelectedBundle?.masterLanguageCode) {
      await this.loadModulePages();
    }

    this.cloneModulePages();
  }

  @action async setTranslationRequiredOnBundle(required: boolean) {
    if (this._SelectedBundle) {
      console.log("globals > setTranslationRequiredOnBundle: required =", required);
      this._SelectedBundle.translationRequired = required;
    }
  }

  @action async addAndSelectModulePage() {
    console.log("globals > addAndSelectModulePage");
    if (!this.selectedExercise) return;

    if (!this._ModulePages) {
      this._ModulePages = [];
    }

    let id = this._ModulePages.length + 1;
    this._ModulePages.push({ id: id, exerciseId: this.selectedExercise.id, title: "Titel", languageCode: this.selectedBundle?.masterLanguageCode ?? "de-DE", courseElements: [], resolutionElements: [] });

    // update id of all module pages
    if (this._ModulePages) {
      for (let i = 0; i < this._ModulePages.length; i++) {
        this._ModulePages[i].id = i + 1;
      }
    }

    await this.selectModulePage(this._ModulePages.length - 1);
  }

  @action async duplicateModulePage(index : number) {
    if (!this._ModulePages) return;
    if (index < 0 || index >= this._ModulePages.length) return;

    let modulePage = this._ModulePages[index];
    let newModulePage = _.cloneDeep(modulePage);
    // regenerate ids and guids for the copied page and its elements to avoid shared references
    const gh = new GlobalHelper();

    function reassignElementIds(elements: any[] | null) {
      if (!elements) return;
      for (let i = 0; i < elements.length; i++) {
        let el = elements[i];
        el.id = i + 1;
        el.guid = gh.getNewGuid();

        if (el.options && Array.isArray(el.options)) {
          for (let j = 0; j < el.options.length; j++) {
            let opt = el.options[j];
            opt.id = j + 1;
            opt.guid = gh.getNewGuid();
          }
        }

        if (el.children && Array.isArray(el.children)) {
          reassignElementIds(el.children);
        }
      }
    }

    if (newModulePage.title && newModulePage.title.length > 53) {
      newModulePage.title = newModulePage.title.substring(0, 53);
    }
    newModulePage.title = newModulePage.title + " - copy";
    newModulePage.id = this._ModulePages.length + 1;

    // regenerate ids/guid for courseElements and resolutionElements
    reassignElementIds(newModulePage.courseElements ?? null);
    reassignElementIds(newModulePage.resolutionElements ?? null);

    this.insertModulePage({ index: index, modulePage: newModulePage });
    // this.selectModulePage(index + 1); // not working
  }

  @mutation insertModulePage({ index, modulePage }) {
    console.log("globals > insertModulePage", index, modulePage);
    if (!this._ModulePages) {
      this._ModulePages = [];
    }

    if (index < 0 || index >= this._ModulePages.length) {
      return;
    }

    this._ModulePages.splice(index + 1, 0, modulePage);

    // update id of all module pages
    if (this._ModulePages) {
      for (let i = 0; i < this._ModulePages.length; i++) {
        this._ModulePages[i].id = i + 1;
      }
    }
  }

  @action async updateModulePage(page: CcPageVm) {
    this.m_updateModulePage(page);
  }

  @mutation m_updateModulePage(page: CcPageVm | null) {
    if (!this._ModulePages || !page) return;

    let index = this._ModulePages.findIndex((p) => p.id == page.id);
    this._ModulePages[index].title = page.title;
  }

  @action async selectModulePage(index : number) {
    this._SelectedModulePage = null;
    await new Promise(resolve => setTimeout(resolve, 10));
    await this.setSelectedModulePage(index);
  }

  @mutation setSelectedModulePage(index: number) {
    // console.log("globals > setSelectedModulePage: ", index);
    if (!this._ModulePages || index < 0 || index >= this._ModulePages.length) {
      // console.log("globals > setSelectedModulePage: _SelectedModulePage = null");
      return;
    }

    this._SelectedModulePage = this._ModulePages[index];
  }

  @action async deleteModulePage(index: number) {
    this.removeModulePage(index);
    if (this._ModulePages && this._ModulePages.length == 0) {
      await this.addAndSelectModulePage();
    }
  }

  @mutation removeModulePage(index: number) {
    console.log("globals > removeModulePage");
    if (!this._ModulePages || index < 0 || index >= this._ModulePages.length) return;

    // if current page is deleted, select the next page to currently selected page
    if (this._ModulePages[index] == this._SelectedModulePage && this._ModulePages.length > 1) {
      if (index == 0) {
        this._SelectedModulePage = this._ModulePages[1];
      } else {
        this._SelectedModulePage = this._ModulePages[index - 1];
      }
    }

    this._ModulePages.splice(index, 1);
  }

  @action async setElement(courseElement: CourseElementVm | null) {
    this.setCourseElement(courseElement);
  }

  @mutation setCourseElement(courseElement: CourseElementVm | null) {
    this._SelectedCourseElement = courseElement;
  }

  @action async refreshSelectedElement() {
    console.log("globals > refreshSelectedElement");
    if (!this._SelectedCourseElement || !this._SelectedExercise || !this._SelectedModulePage) return;

    // before loading the element, save the current module pages if there are changes
    await this.saveModulePages(false);

    let param = <ParamDictionary>{dictionary: {}};
    param.dictionary!["ExerciseId"] = this._SelectedExercise.id.toString();
    param.dictionary!["PageId"] = this._SelectedModulePage.id.toString();
    param.dictionary!["ElementId"] = this._SelectedCourseElement.id.toString();
    const languageCode = this._SelectedLanguageCode ?? this._SelectedBundle?.masterLanguageCode ?? "de-DE";
    param.dictionary!["LanguageCode"] = languageCode;

    await rest.url("contentManager/loadPageElement")
      .post(param)
      .then(async (response) => {
        if (
          !response ||
          // Make sure that the selection is still the same as before
          param.dictionary!["ExerciseId"] != this._SelectedExercise?.id.toString() ||
          param.dictionary!["PageId"] != this._SelectedModulePage?.id.toString() ||
          param.dictionary!["ElementId"] != this._SelectedCourseElement?.id.toString() ||
          param.dictionary!["LanguageCode"] != languageCode
        ) return;
        // save pages before updating the selected element

        await this.resetSelectedCourseElement();
        await new Promise(resolve => setTimeout(resolve, 5));
        await this.updateCourseElement(response);
      })
      .finally(() => {
      });
  }

  @mutation resetSelectedCourseElement() {
    if (!this._SelectedCourseElement) return;

    // Reset ContentUlr to force update of audio and video elements
    this._SelectedCourseElement.contentUrl = null;
  }

  @mutation updateCourseElement(courseElement: CourseElementVm) {
    if (!this._SelectedCourseElement) return;

    this._SelectedCourseElement.title = courseElement.title;
    this._SelectedCourseElement.text = courseElement.text;
    this._SelectedCourseElement.aiSummary = courseElement.aiSummary;
    this._SelectedCourseElement.file = courseElement.file;
    this._SelectedCourseElement.contentUrl = courseElement.contentUrl;
    this._SelectedCourseElement.createdWithAi = courseElement.createdWithAi;
 }

  @action async refreshSelectedBundle() {
    console.log("globals > refreshSelectedBundle");
    if (!this._SelectedBundle) return;

    let param = <ParamDictionary>{dictionary: {}};
    param.dictionary!["BundleId"] = this._SelectedBundle?.id.toString() ?? "";

    await rest.url("contentManager/loadExBundle")
      .post(param)
      .then(async (response) => {
        if (
          !response ||
          // Make sure that the selection is still the same as before
          param.dictionary!["BundleId"] != this._SelectedBundle?.id.toString()
        ) return;

        await new Promise(resolve => setTimeout(resolve, 5));
        await this.setBundle(response);
      })
      .finally(() => {
      });
  }

  // mutations
  @mutation setUser(user: PortalUserVM | null) {
    this.sSelectedUser = user;
  }
  @mutation setUsersOfGroup(users: PortalUserVM[]) {
    this.sSelectedGroupMembers = users;
  }
  @mutation setOrg(org: OrganizationVm | null) {
    this.sSelectedOrg = org;
  }
  @mutation setGroup(group: GroupExtVm | null) {
    this.sSelectedGroup = group;
  }
  @mutation setSubGroup(subGroup: SubGroupVm | null) {
    this.sSelectedSubGroup = subGroup;
  }
  @mutation setCategory1(cat1: ExCategory1 | null) {
    this.sSelectedCategory1 = cat1;
  }
  @mutation setCategory2(cat2: ExCategory2 | null) {
    this.sSelectedCategory2 = cat2;
  }
  @mutation setCategory3(cat3: ExCategory3 | null) {
    this.sSelectedCategory3 = cat3;
  }
  @mutation setExBundleAssignment(exBundleAssignment: ExBundleAssignmentVM) {
    this.sSelectedExBundleAssignment = exBundleAssignment;
  }
  @mutation setGroupAssignment(exBundleAssignment: ExBundleAssignmentVM) {
    this.sGroupAssignment = exBundleAssignment;
  }
  @mutation setBundle(bundle: ExBundleVM | null) {
    this._SelectedBundle = bundle;
  }
  @mutation setSelectedLanguageCode(selectedLanguageCode: string | null) {
    this._SelectedLanguageCode = selectedLanguageCode;
  }
  @mutation setExercise(exercise: ExerciseVM | null) {
    // console.log("globals > setExercise and clear pages[]", exercise?.id ?? "0");
    this._SelectedExercise = exercise;
    this._ModulePages = [];
    this._SelectedModulePage = null; // reset selected module page when exercise changes
  }
  @mutation setSurvey(survey: ExSurveyVm) {
    this._SelectedSurvey = survey;
  }
  @mutation setShowPrintUsersQrCode() {
    this.sShowPrintUsersQrCode = !this.showPrintUsersQrCode;
    this.sIsInPrintMode = true;
  }
  @mutation setViewToPrintMode(enablePrintView: boolean) {
    this.sIsInPrintMode = enablePrintView;
  }
  @mutation setGroupExerciseOverviewSortByAlphabet(value: boolean) {
    this.sGroupExerciseOverviewSortByAlphabet = value;
  }
  @mutation setGroupExerciseOverviewSortOrderAscending(value: boolean) {
    this.sGroupExerciseOverviewSortOrderAscending = value;
  }
  // setChildQuestions(value: ExQuestion[] | null) => {
  //   this.childQuestions = value;
  // }
  // setSelectedChildQuestionId(value: number) => {
  //   this.selectedChildQuestionId = value;
  // }
  // setSelectedChildQuestion(value: ExQuestion) => {
  //   if (!this.childQuestions)
  //     return;

  //   this.childQuestions[this.selectedChildQuestionId] = value;
  // }
};
